import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  AnswerRateDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplayHmdResponseRateSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.HMD_RESPONSE_RATE?.submetrics) {
    return <></>;
  }
  if (AnswerRateDataCheck(metrics.HMD_RESPONSE_RATE?.submetrics!)) {
    return <NoSubMetric />;
  }
  const { totalHmdResponses, offerCount } =
    metrics.HMD_RESPONSE_RATE?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {offerCount && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <Text type={SUBMETRIC_FONT_SIZE}>
            <FormattedMessage
              id='cs_perfportal_offerings'
              defaultMessage='Offerings'
            />
          </Text>
          <DisplaySubMetric value={offerCount.datapoint} isBold />
        </Row>
      )}
      {totalHmdResponses && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <Text type={SUBMETRIC_FONT_SIZE}>
            <FormattedMessage
              id='cs_perfportal_responses'
              defaultMessage='Responses'
            />
          </Text>
          <DisplaySubMetric value={totalHmdResponses.datapoint} isBold />
        </Row>
      )}
    </Column>
  );
};

export default DisplayHmdResponseRateSubMetrics;
